import { Hide, IconButton, Input, Select, Show } from "shared/components";
import { FieldName, type Rule as RuleT } from "../types";
import {
  defaultOperator,
  defaultValues,
  fieldNameOptions,
  fieldOperators,
  fieldTypeOptions,
  PERCENTAGE_INPUT_LENGTH
} from "../constants";
import { Minus } from "untitledui-js-base";
import { useTemplateContext } from "shared/app/VerificationTemplate/provider";

export const Rule = ({
  field_name,
  field_type,
  operator,
  value,
  updateRule,
  removeRule
}: RuleT & {
  updateRule: (field: string, value: string | undefined) => void;
  removeRule: () => void;
}) => {
  const { readOnly } = useTemplateContext();

  return (
    <div className="flex items-center gap-2 animate-appear flex-wrap md:flex-nowrap">
      <div className="w-full flex items-center gap-2">
        <Select
          isDisabled={readOnly}
          options={fieldNameOptions}
          value={field_name}
          id="field_name"
          className="w-full"
          key={field_name}
          onChange={(e) => {
            if (fieldTypeOptions[e.target.value]) {
              const options = fieldTypeOptions[e.target.value];
              updateRule("field_type", options[0].value);
            }
            updateRule("field_name", e.target.value);
            updateRule("operator", defaultOperator[e.target.value]);
            updateRule("value", defaultValues[e.target.value]);
          }}
        />
        {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
        <Show if={(fieldTypeOptions[field_name]?.length || 0) > 1}>
          <Select
            isDisabled={readOnly}
            key={field_name}
            options={fieldTypeOptions[field_name]}
            value={field_type}
            id="field_type"
            className="w-full max-w-[175px]"
            onChange={(e) => {
              updateRule("field_type", e.target.value);
            }}
          />
        </Show>
      </div>

      <Hide
        if={[FieldName.SexOffenderCheck, FieldName.NoCreditScore].includes(
          field_name
        )}
      >
        <Select
          isDisabled={readOnly}
          className="max-w-[170px] w-full"
          key={field_name}
          options={fieldOperators[field_name]}
          value={operator}
          id="operator"
          onChange={(e) => updateRule("operator", e.target.value)}
        />
      </Hide>

      {![FieldName.SexOffenderCheck, FieldName.NoCreditScore].includes(
        field_name
      ) ? (
        <Input
          className="max-w-[100px] min-w-[85px] text-right"
          value={value}
          maxLength={
            field_name === FieldName.CreditScore
              ? 3
              : field_type === "percentage"
                ? PERCENTAGE_INPUT_LENGTH
                : undefined
          }
          onBlur={(e) => {
            if (e.target.value && field_name === FieldName.CreditScore)
              if (parseInt(e.target.value) < 300) updateRule("value", "350");
              else if (parseInt(e.target.value) > 850)
                updateRule("value", "850");

            if (field_type === "percentage") {
              const normalizedValue = String(
                Number(e.target.value.replaceAll("%", ""))
              );

              updateRule("value", normalizedValue);
            }
          }}
          readOnly={readOnly}
          id="value"
          key={field_name}
          type={
            field_type === "percentage"
              ? "percentage"
              : field_type === "numeric"
                ? "number"
                : [
                      FieldName.GrossIncome,
                      FieldName.NetIncome,
                      FieldName.PastDueAccount,
                      FieldName.CollectionsBalance,
                      FieldName.UnpaidCollectionsBalance
                    ].includes(field_name)
                  ? "money"
                  : "number"
          }
          noIntlNormalization={
            field_name === FieldName.GrossIncomeToRentRatio ||
            field_type === "percentage"
          }
          onChange={(e) => {
            updateRule("value", e.target.value.replaceAll("%", ""));
          }}
        />
      ) : (
        <Select
          isDisabled={readOnly}
          className="max-w-[100px] w-full"
          key={field_name}
          options={[
            {
              label: "Yes",
              value: 1
            },
            {
              label: "No",
              value: 0
            }
          ]}
          value={Number(value)}
          id="value"
          onChange={(e) => updateRule("value", e.target.value)}
        />
      )}

      <Hide if={readOnly}>
        <IconButton
          Icon={Minus}
          className="shrink-0 mb-2"
          onClick={() => {
            removeRule();
          }}
        />
      </Hide>
    </div>
  );
};
